import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'How long is the free trial?',
    a: '14 days with full access to all features. No credit card required. You can upgrade or cancel at any time during the trial.',
  },
  {
    q: 'Can my subcontractors use it without an account?',
    a: 'Yes. The subcontractor portal is token-based — you send them a unique link and they can view job details, sign lien waivers, and upload documents without creating an account.',
  },
  {
    q: 'Does it work on mobile?',
    a: 'The One Build is a fully responsive web application. It works in any modern browser on phones, tablets, and desktops. No app to install.',
  },
  {
    q: 'Can I generate lien waivers automatically?',
    a: 'Yes. The One Build generates conditional and unconditional lien waivers based on your payment milestones. You can send them to subs for e-signature directly from the portal.',
  },
  {
    q: 'How does e-signing work?',
    a: 'Contracts, change orders, and lien waivers can all be sent for electronic signature. Recipients get an email link, review the document, and sign. You get a timestamped audit trail.',
  },
  {
    q: 'Can I import my existing job data?',
    a: 'Yes. You can import jobs, contacts, and subcontractor lists from CSV. For Enterprise customers, we offer custom migration assistance.',
  },
  {
    q: 'Is my data secure?',
    a: 'All data is encrypted in transit (TLS 1.3) and at rest. We run on Microsoft Azure with SOC 2-compliant infrastructure. Your data is never shared with third parties.',
  },
  {
    q: 'What happens if I cancel?',
    a: 'You can export all your data at any time. After cancellation, your data is retained for 90 days in case you change your mind, then permanently deleted.',
  },
];

export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="relative py-28 sm:py-32">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-16 text-center reveal">
          <span className="mb-4 inline-block rounded-full border border-build-700/40 bg-build-900/40 px-3 py-1 text-xs font-medium text-orange-400">
            FAQ
          </span>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Common Questions
          </h2>
        </div>

        <div className="space-y-3 reveal">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-xl border border-build-700/30 bg-build-900/20">
              <button
                className="flex w-full items-center justify-between px-5 py-4 text-left"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="pr-4 text-sm font-medium text-zinc-200">{faq.q}</span>
                <ChevronDown
                  className={`h-4 w-4 shrink-0 text-zinc-500 transition-transform ${open === i ? 'rotate-180' : ''}`}
                />
              </button>
              <div className={`faq-answer ${open === i ? 'open' : ''}`}>
                <p className="px-5 pb-4 text-sm leading-relaxed text-zinc-400">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
